import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { DrumPortrait } from "@/components/DrumPortrait";
import { formatCHF } from "@/lib/api";
import { useLocale } from "@/context/LocaleContext";

export const ProductCard = ({ product, index = 0 }) => {
  const { t } = useLocale();
  return (
  <motion.div
    initial={{ opacity: 0, y: 32 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, delay: (index % 3) * 0.12, ease: [0.22, 1, 0.36, 1] }}
  >
    <Link
      to={`/boutique/tambour/${product.id}`}
      data-testid={`product-card-${product.numero.replace(/\s/g, "-").toLowerCase()}`}
      className="group block bg-card border border-sand-dark rounded-2xl overflow-hidden hover:-translate-y-1.5 hover:shadow-xl hover:shadow-earth/10 transition-all duration-500"
    >
      <div className="relative aspect-square bg-earth grain spotlight flex items-center justify-center overflow-hidden">
        {product.image ? (
          <img src={product.image} alt={`Tambour ${product.nom}`} loading="lazy"
            className="relative z-[2] w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
        ) : (
          <div className="relative z-[2] w-3/4 transition-transform duration-700 group-hover:scale-105 group-hover:rotate-3">
            <DrumPortrait peau={product.couleur_peau} bois={product.couleur_bois} />
          </div>
        )}
        <span className={`absolute top-4 left-4 z-[2] font-mono text-[10px] uppercase tracking-[0.25em] px-3 py-1.5 rounded-full ${
          product.disponible ? "bg-sage/90 text-sand" : "bg-sand/20 text-sand/70"
        }`}>
          {product.disponible ? t("Pièce unique") : t("A trouvé sa maison")}
        </span>
      </div>
      <div className="p-6">
        <div className="flex items-baseline justify-between gap-3">
          <h3 className="font-serif text-xl text-bark group-hover:text-terra transition-colors duration-300">{product.nom}</h3>
          <span className="font-mono text-[10px] text-fumee tracking-widest">{product.numero}</span>
        </div>
        <p className="text-sm text-fumee mt-1">{[product.peau, product.forme !== "Accessoire" ? product.forme : null, product.diametre ? `${product.diametre} cm` : null].filter(Boolean).join(" · ")}</p>
        <div className="flex items-center justify-between mt-4">
          <span className="font-serif text-lg text-terra">{formatCHF(product.prix)}</span>
          <span className="text-xs text-fumee link-line">{t("Découvrir")}</span>
        </div>
      </div>
    </Link>
  </motion.div>
  );
};
